import type { SxProps, Theme } from '@mui/material';

export type TabMultiselectChipVariant = 'tag' | 'qualifier';

const CHIP_STYLES_BY_VARIANT = {
  tag: {
    backgroundColor: 'rgba(76, 175, 80, 0.12)',
    borderColor: 'rgba(56, 142, 60, 0.28)',
    color: 'rgb(27, 94, 32)',
  },
  qualifier: {
    backgroundColor: 'rgba(33, 150, 243, 0.12)',
    borderColor: 'rgba(25, 118, 210, 0.28)',
    color: 'rgb(13, 71, 161)',
  },
} as const;

export const getTabMultiselectFieldSx = (
  chipVariant: TabMultiselectChipVariant,
): SxProps<Theme> => {
  const chipColors = CHIP_STYLES_BY_VARIANT[chipVariant];

  return {
    '& .MuiInputLabel-root': {
      color: 'text.secondary',
      fontSize: '0.875rem',
      fontWeight: 500,
      letterSpacing: '0.01em',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(0, 0, 0, 0.1)',
      transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    },
    '& .MuiOutlinedInput-root': {
      alignItems: 'center',
      backgroundColor: '#f7f6f3',
      borderRadius: 1,
      flexWrap: 'wrap',
      gap: 0.75,
      minHeight: 52,
      py: 1,
      px: 1.25,
      transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(0, 0, 0, 0.18)',
      },
      '&.Mui-focused': {
        backgroundColor: 'background.paper',
        boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.1)',
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'primary.main',
          borderWidth: '1px',
        },
      },
    },
    '& .MuiChip-root': {
      ...chipColors,
      border: '1px solid',
      borderRadius: '16px',
      fontSize: '0.8125rem',
      fontWeight: 500,
      height: 'auto',
      minHeight: 32,
      py: 0.25,
      '& .MuiChip-deleteIcon': {
        color: 'inherit',
        fontSize: 16,
        margin: '0 6px 0 2px',
        opacity: 0.65,
        '&:hover': {
          opacity: 1,
        },
      },
      '& .MuiChip-label': {
        lineHeight: 1.4,
        padding: '0 2px 0 8px',
        py: 0.75,
      },
    },
    '& input': {
      color: 'text.primary',
      fontSize: '0.875rem',
      minWidth: 140,
      '&::placeholder': {
        color: 'text.disabled',
        opacity: 1,
      },
    },
  };
};

export const tabMultiselectWrapperSx: SxProps<Theme> = {
  mb: 1,
  mt: 2,
};
